module.exports = __webpack_public_path__ + "assets/AngleTrisection54Detailed.9a59da57d8364fe0ae8ee173dd6ef301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AngleTrisection54Detailed.png
// module id = 468
// module chunks = 0